import { useEffect, useState } from "react";

import SubHeader from "components/common/SubHeader";

import "assets/scss/pages/term.scss";

const terms = [
    {
        url: "terms",
        modalTitle: "이용약관",
        type: 1,
    },
    {
        url: "privacy",
        modalTitle: "개인정보 수집및 이용동의",
        type: 2,
    },
];

const Term = () => {
    const path = window.location.pathname;

    const [termsContent, setTermsContent] = useState("");
    const [modalTitle, setModalTitle] = useState("");

    useEffect(() => {
        const term = terms.find((term) => term.url === path.split("/").pop());
        fetch(`${process.env.PUBLIC_URL}/agreement/${term.url}.txt`)
            .then((response) => response.text())
            .then((data) => {
                setTermsContent(data);
                setModalTitle(term.modalTitle);
            })
            .catch((error) => console.error("Error fetching terms:", error));
    }, [path]);

    return (
        <>
            <SubHeader title={modalTitle} />
            <div className="term-wrap">
                <div className="term-contents">
                    <p>{termsContent}</p>
                </div>
            </div>
        </>
    );
};

export default Term;
